export type QualityRecordSearchField = 'prefix' | 'indexing';

/**
 * Search fields of the Generated Records listing. Each id is the field of `QualityRecordRow` the
 * search matches the term against, and is also what goes to the URL, so a future listing route can
 * read the same value.
 */
export const QUALITY_RECORD_SEARCH_FIELDS: { id: QualityRecordSearchField; name: string }[] = [
  { id: 'prefix', name: 'Registros gerados' },
  { id: 'indexing', name: 'Indexador' },
];

export const DEFAULT_QUALITY_RECORD_SEARCH_FIELD: QualityRecordSearchField = 'prefix';

